import { MenuT } from 'types/frontend/Menu';
import { MyInfoT } from 'types/shared/core/User';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const postMenuRootPath = '/teacherSide/post';

const postMenu: MenuT = [
  {
    title: t('모든 글'),
    items: [
      {
        title: t('원공지'),
        path: `${postMenuRootPath}/generalBoard`,
      },
      {
        title: t('클래스'),
        path: `${postMenuRootPath}/classBoard`,
      },
      {
        title: t('알림장'),
        path: `${postMenuRootPath}/note`,
      },
      {
        title: t('브랜드'),
        path: `${postMenuRootPath}/brand`,
        visibilityCriteria: (myInfo: MyInfoT | null) =>
          !!myInfo?.teacherInfo?.academy.publicSetting?.confBrandHasSubscription,
      },
    ],
  },
  {
    title: t('글 검토'),
    items: [
      {
        title: t('검토 대기 글'),
        path: `${postMenuRootPath}/review/inbox`,
        visibilityCriteria: (myInfo: MyInfoT | null) =>
          !!myInfo?.teacherInfo?.academy.insiderSetting?.feaPostReview,
      },
      {
        title: t('나의 검토 요청글'),
        path: `${postMenuRootPath}/review/mine`,
        accessablePositions: ['director', 'assistantDirector'],
        visibilityCriteria: (myInfo: MyInfoT | null) =>
          !!myInfo?.teacherInfo?.academy.insiderSetting?.feaPostReview,
      },
    ],
  },
  {
    title: t('글 쓰기'),
    items: [
      {
        title: t('게시글 쓰기'),
        path: `${postMenuRootPath}/writeBoardPost`,
      },
      {
        title: t('알림장 쓰기'),
        path: `${postMenuRootPath}/writeNotePost`,
      },
    ],
  },
];

export { postMenu };
